var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card-body" }, [
        _c(
          "div",
          { staticClass: "form-group" },
          [
            _c("label", [_vm._v("Поиск по препарту")]),
            _vm._v(" "),
            _c("DrugSearchNew", {
              ref: "searchDrug",
              attrs: { onSelect: (d) => _vm.selectDrug(d) },
            }),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card" }, [
      _c(
        "div",
        { staticClass: "card-body" },
        [
          _c("AdjustInvoices", {
            ref: "AdjustInvoices",
            attrs: { drug: _vm.selectedDrug },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }